import { render, staticRenderFns } from "./asesorHome.vue?vue&type=template&id=efff96be&scoped=true"
import script from "./asesorHome.vue?vue&type=script&lang=js"
export * from "./asesorHome.vue?vue&type=script&lang=js"
import style0 from "./asesorHome.vue?vue&type=style&index=0&id=efff96be&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "efff96be",
  null
  
)

export default component.exports